import { getComponent } from "../../ComponentsMap";
import testImage from '../../Assets/Images/Screenshot (2157).png'
import { CampaignService } from "../../Services/Axios/Api";
import { useEffect, useState } from "react";
const CampaignsPage = () => {
    const data = [
        {
            id: 1,
            title: 'title',
            description: 'description',
            image: testImage,
            compName: 'NormalDonationCard',
        },
        {
            id: 2,
            title: 'title',
            description: 'description',
            image: testImage,
            current: 70,
            target: 150,
            className: 'ProgressCard',
            compName: 'ProgressingDonationCard',
            style: [
                { "background-color": "grey" },
                { "color": "white" },
            ]
        },
        {
            id: 3,
            className: 'ProgressCard',
            title: 'title',
            description: 'description',
            compName: 'ProgressingDonationCard',
            image: testImage,
            current: 70,
            target: 150,
        }
    ];

    const [campaigns, setCampaigns] = useState([]);
    useEffect(() => {
        const fetchCampaigns = async () => {
            const response = await CampaignService.getActiveCampaigns(true);
            setCampaigns(response.result);
        };
        fetchCampaigns();
    }, []);
    

    return (
        <div className="Donations mt-5">
            <div className="container">
                <div className="row">
                    {/* {data.map((row) => (
                        getComponent(row.compName, row)
                    ))} */}
                </div>
                {campaigns.filter(c => !c.section.isGeneralDonation).map(row => ({
                    ...row,
                    campaigns: row.campaigns?.filter(c => c.isVisible !== false)
                })).filter(row => row.campaigns?.length > 0).slice(0, 2).map((row) => (
                    getComponent('Campaigns', row)
                ))}
                <div className="mb-5">
                    {getComponent('Campaigns', { CampaignType: "Normal" })}
                </div>
                <div className="mt-5 mb-5">
                    {getComponent('Campaigns', { CampaignType: "Progressing" })}
                </div>
            </div>
        </div>
    );
};

export default CampaignsPage;
